import React, { Component } from 'react';

class TaskComponent extends Component {
    state = {
        isImageLoaded: false,
    };

    componentDidUpdate(prevProps) {
        // If the item changes, reset the image loaded state to false
        if (prevProps.item !== this.props.item) {
            this.setState({ isImageLoaded: false });
        }
    }

    handleRemove = () => {
        const { onRemove } = this.props;
        if (onRemove) {
            onRemove();
        }
    };

    generateResultUrl = (item) => {
        if (this.props.resizeImage) {

            return `${process.env.REACT_APP_API_PATH}/prod/public/download/image?project_name=${item.project_name}&seq=${item.seq}&type=output&version=${item.version}&width=${this.props.width}&height=${this.props.height}`;

        }
        else {
            return `${process.env.REACT_APP_API_PATH}/prod/public/download/image?project_name=${item.project_name}&seq=${item.seq}&type=output&version=${item.version}`;

        };
    }

    handleImageLoad = () => {
        this.setState({ isImageLoaded: true });
    };

    render() {
        const { item, isSelected, isCurrent, width, height, resizeImage } = this.props;
        const { isImageLoaded } = this.state;

        return (
            <div
                style={{
                    width: width,
                    height: height,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    border: isSelected
                        ? isCurrent
                            ? '2px solid #db03fc'
                            : '2px solid #f00'
                        : isCurrent
                            ? '2px solid blue'
                            : '2px solid #fff',
                    cursor: 'pointer',
                    margin: '2px',
                    borderRadius: '5px',
                    backgroundColor: 'white', // Optional for better visibility
                }}
                onClick={() => {
                    this.props.onClick(item);
                }}
            >
                {item.status === "succeed" && isImageLoaded ? (
                    <img
                        src={this.generateResultUrl(item)}
                        alt={item.name || "result"}
                        style={{
                            width: '100%',
                            height: '100%',
                            borderRadius: '5px',
                            objectFit: 'cover',
                        }}
                        onLoad={this.handleImageLoad}
                    />
                ) : (
                    <span
                        style={{
                            fontSize: '2rem',
                            color: '#666',
                            fontWeight: 'bold',
                        }}
                    >
                        ?
                    </span>
                )}
                {/* Preload the image */}
                {item.status === "succeed" && !isImageLoaded && (
                    <img
                        src={this.generateResultUrl(item)}
                        alt=""
                        style={{ display: 'none' }}
                        onLoad={this.handleImageLoad}
                    />
                )}
            </div>
        );
    }
}

// Set default width and height
TaskComponent.defaultProps = {
    width: 100,
    height: 100,
};

export default TaskComponent;
